if (!customElements.get('main-blog-component')) {
    customElements.define(
      'main-blog-component',
      class MainBlogComponent extends HTMLElement {
        constructor() {
          super();
          this.section = this.getAttribute('section');
          this.currentBlogHandle = this.getAttribute('blog-handle'); // Get the current blog handle from Liquid
          this.handleTabFilter();
        }
  
        handleTabFilter() {
          const tabs = this.querySelectorAll('.blogs-cards__filter-item');
          const container = this.querySelector('.blogs-cards__cards-wrapper');
          const paginationLinks = this.querySelector('.blogs-cards__pagination');
  
          tabs.forEach((tab) => {
            tab.addEventListener('click', (e) => {
              const selectedBlogHandle = e.target.getAttribute('data-blog-handle');
              //   if (selectedBlogHandle !== this.currentBlogHandle) {
              this.fetchBlogPosts(selectedBlogHandle)
                .then((data) => {
                  if (data) {
                    // Parse the returned HTML and replace the relevant section content
                    const parser = new DOMParser();
                    const htmlDoc = parser.parseFromString(data['main-blog'], 'text/html');
  
                    const newContent = htmlDoc.querySelector('.blogs-cards__cards-wrapper');
                    const newPagination = htmlDoc.querySelector('.blogs-cards__pagination');
  
                    if (newContent) {
                      container.innerHTML = newContent.innerHTML; // Replace the content
                    }
  
                    if (newPagination) {
                      paginationLinks.innerHTML = newPagination.innerHTML; // Update pagination
                    }
  
                    // Update URL without reloading
                    window.history.pushState({}, '', `/blogs/${selectedBlogHandle}`);
  
                    // Update the active tab
                    tabs.forEach((t) => t.classList.remove('blogs-cards__filter-item--active'));
                    tab.classList.add('blogs-cards__filter-item--active');
  
                    this.currentBlogHandle = selectedBlogHandle;
                  }
                })
                .catch((error) => {
                  console.error('Failed to fetch blog posts:', error);
                });
              //   }
            });
          });
        }
  
        async fetchBlogPosts(blogHandle) {
  
          try {
            const response = await fetch(`/blogs/${blogHandle}/?sections=main-blog`);
            const data = await response.json(); // Parse response as 
            return data; // Return the JSON object
          } catch (error) {
            console.error('Failed to fetch blog posts:', error);
            return null;
          }
        }
      }
    );
  }
  